import { Schema } from 'effect';

import { emailRegex } from '../config/regex';

import { String } from './string';

export const Email = String.check(
  Schema.isPattern(emailRegex, { message: 'Vyplňte platnou e-mailovou adresu!' })
);
